<template>
  <section class="aboutUs smallSectionMargins">
    <div class="titleAndRichTextContent container--Medium">
      <h2 class="titleAndRichTextContent__Title" v-text="data.title" />
      <div class="titleAndRichTextContent__Texts" v-html="data.description" />
    </div>
  </section>
</template>

<script setup>
  defineOptions({
    autoImportStyles: false
  });
  
  defineProps({
    data: {}
  })
</script>